

export enum TRACKBILL_STATUS {
    NOT_PAY = "NOT_PAY",//ค้างชำระ
    WAITING = "WAITING" // รอชำระ
}

export const trackbill_status_data: { label: string, value: string }[] = [
    {
        label: "ค้างชำระ",
        value: TRACKBILL_STATUS.NOT_PAY
    },
    {
        label: "รอการชำระเงิน",
        value: TRACKBILL_STATUS.WAITING
    },
]